import { FC } from 'react'
import React from 'react'
import Axios from 'axios'
import { Col, Descriptions, message, Row } from 'antd'
import Dragger from 'antd/lib/upload/Dragger'
import { InboxOutlined, PaperClipOutlined } from '@ant-design/icons'

const UploadGateway: FC = () => {
    const opt = {
        name: 'file',
        multiple: false,
        customRequest: async (e: any) => {
            const formData = new FormData()
            formData.append('file', e.file, e.file.name)
            try {
                const res = await Axios.patch(`/gateways`, formData, {
                    headers: {
                        'Content-Type': `multipart/form-data`,
                    },
                })
                e.onSuccess()
                downloadCsv(res.data)
            } catch (err) {
                console.error(err)
            }
        },
        onChange(info: any) {
            const { status } = info.file
            if (status !== 'uploading') {
                console.log(info.file, info.fileList)
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`)
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`)
            }
        },
    }

    const downloadCsv = (data: any) => {
        let csv = ''
        data.forEach(function (row: any) {
            csv += row.join(',')
            csv += '\n'
        })
        const hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = 'result.csv'
        hiddenElement.click()
    }
    return (
        <Row>
            <Col>
                <Dragger {...opt}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Support for a single or bulk upload. Strictly prohibit from uploading company data or other band
                        files
                    </p>
                </Dragger>

                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <div>
                        <PaperClipOutlined />
                        <a href="/template/gateway/add.xlsx">Add.xlsx</a>
                    </div>
                    <div>
                        <PaperClipOutlined />
                        <a href="/template/gateway/update.xlsx">Update.xlsx</a>
                    </div>
                    <div>
                        <PaperClipOutlined />
                        <a href="/template/gateway/remove.xlsx">Remove.xlsx</a>
                    </div>
                </div>

                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <div>
                        <Descriptions title="Add to local" layout="horizontal" column={1} bordered>
                            <Descriptions.Item label="gatewayId">Gateway ID</Descriptions.Item>
                            <Descriptions.Item label="routerId">Router ID</Descriptions.Item>
                            <Descriptions.Item label="district">gateway district</Descriptions.Item>
                            <Descriptions.Item label="action">ADD / UPDATE / REMOVE</Descriptions.Item>
                        </Descriptions>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default UploadGateway
